module.exports = __webpack_public_path__ + "static/media/10-4.ee0b7602.mp3";